import { isSameDay } from 'date-fns'

const WEEK_DAY_COUNT = 7
export const WEEK_FIVE_MINUTE_ROW_HEIGHT = 5.5
export const WEEK_HALF_HOUR_ROW_HEIGHT = WEEK_FIVE_MINUTE_ROW_HEIGHT * 6
export const WEEK_GRID_TOP_OFFSET = 28

export const getWeekCurrentTimeIndicatorPosition = (displayedWeek, now) => {
  if (!Array.isArray(displayedWeek) || !now) return null

  const dayIndex = displayedWeek.findIndex((day) => isSameDay(day, now))
  if (dayIndex < 0) return null

  const minutesSinceMidnight = (now.getHours() * 60) + now.getMinutes()
  return {
    dayIndex,
    leftPercent: (dayIndex / WEEK_DAY_COUNT) * 100,
    widthPercent: 100 / WEEK_DAY_COUNT,
    topPx: WEEK_GRID_TOP_OFFSET
      + ((minutesSinceMidnight / 5) * WEEK_FIVE_MINUTE_ROW_HEIGHT),
  }
}
